
import { useFormContext } from 'react-hook-form';
// @mui
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Unstable_Grid2';
import CardHeader from '@mui/material/CardHeader';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// components
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  fields: any[];
  loaiCameraOptions: any[];
  onAdd: VoidFunction;
  onRemove: (index: number) => void;
};

export default function LoSamCameraForm({
  fields,
  loaiCameraOptions,
  onAdd,
  onRemove,
}: Props) {
  const mdUp = useResponsive('up', 'md');
  const { watch, setValue } = useFormContext();
  const values = watch();

  return (
    <>
      {mdUp && (
        <Grid md={3}>
          <Typography variant="h6" sx={{ mb: 0.5 }}>
            Camera
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Thông tin camera giám sát lô sâm...
          </Typography>
        </Grid>
      )}

      <Grid xs={12} md={9}>
        <Card>
          {!mdUp && <CardHeader title="Camera" />}

          <Stack spacing={3} sx={{ p: 3 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="subtitle1">Danh sách camera</Typography>
              <Button
                variant="outlined"
                startIcon={<Iconify icon="mingcute:add-line" />}
                onClick={onAdd}
              >
                Thêm camera
              </Button>
            </Stack>

            {fields.length > 0 && (
              <TableContainer component={Paper} variant="outlined">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Loại camera</TableCell>
                      <TableCell>OnvifCamera</TableCell>
                      <TableCell>IPCamera</TableCell>
                      <TableCell>RTSP</TableCell>
                      <TableCell>Username</TableCell>
                      <TableCell>Password</TableCell>
                      <TableCell width={50} />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fields.map((field, index) => (
                      <TableRow key={field.id}>
                        <TableCell>
                          <FormControl fullWidth size="small">
                            <Select
                              value={values.cameras[index]?.loSamLoaiCameraId || 1}
                              onChange={(event) => setValue(`cameras.${index}.loSamLoaiCameraId`, Number(event.target.value))}
                            >
                              {loaiCameraOptions.map((option) => (
                                <MenuItem key={option.value || 'key'} value={option.value || ''}>
                                  {option.text}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            value={values.cameras[index]?.rtsp || ''}
                            onChange={(event) => setValue(`cameras.${index}.rtsp`, event.target.value)}
                            placeholder="rtsp://..."
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            value={values.cameras[index]?.ipCamera || ''}
                            onChange={(event) => setValue(`cameras.${index}.ipCamera`, event.target.value)}
                            placeholder="192.168.1.1..."
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            value={values.cameras[index]?.onvifCamera || ''}
                            onChange={(event) => setValue(`cameras.${index}.onvifCamera`, event.target.value)}
                            placeholder="0"
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            value={values.cameras[index]?.userName || ''}
                            onChange={(event) => setValue(`cameras.${index}.userName`, event.target.value)}
                            placeholder="admmin..."
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            value={values.cameras[index]?.password || ''}
                            onChange={(event) => setValue(`cameras.${index}.password`, event.target.value)}
                            type="password"
                            placeholder="1231..."
                          />
                        </TableCell>
                        <TableCell>
                          <IconButton
                            color="error"
                            onClick={() => onRemove(index)}
                          >
                            <Iconify icon="mingcute:delete-2-line" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {fields.length === 0 && (
              <Box
                sx={{
                  textAlign: 'center',
                  py: 3,
                  color: 'text.secondary',
                }}
              >
                <Typography variant="body2">
                  Chưa có camera nào. Nhấn &quot;Thêm camera&quot; để bắt đầu.
                </Typography>
              </Box>
            )}
          </Stack>
        </Card>
      </Grid>
    </>
  );
}
